module.exports = __webpack_public_path__ + "img/private.f00a68bc.svg";